var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { request } from "../request";
export var submissionGETdata = function (endpoint, setSubmissionData) { return __awaiter(void 0, void 0, void 0, function () {
    var GET_SUBMISSION_ENDPOINT;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                GET_SUBMISSION_ENDPOINT = "" + process.env.REACT_APP_API_GATEWAY_URL + endpoint;
                return [4 /*yield*/, request.get(GET_SUBMISSION_ENDPOINT).then(function (response) {
                        if (!response.success)
                            console.log("Error: " + response.message + " " + response.success);
                        else
                            setSubmissionData(response);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var submissionPOSTdata = function (endpoint, setSubmissionData, requestBody) { return __awaiter(void 0, void 0, void 0, function () {
    var POST_SUBMISSION_ENDPOINT, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                POST_SUBMISSION_ENDPOINT = "" + process.env.REACT_APP_API_GATEWAY_URL + endpoint;
                data = requestBody.data;
                return [4 /*yield*/, request.post(POST_SUBMISSION_ENDPOINT, data).then(function (response) {
                        if (!response.success)
                            console.log("Error: " + response.message + " " + response.success);
                        else
                            setSubmissionData(response);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var submissionPUTdata = function (endpoint, setSubmissionData, requestBody) { return __awaiter(void 0, void 0, void 0, function () {
    var PUT_SUBMISSION_ENDPOINT, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                PUT_SUBMISSION_ENDPOINT = "" + process.env.REACT_APP_API_GATEWAY_URL + endpoint;
                data = requestBody.data;
                return [4 /*yield*/, request.put(PUT_SUBMISSION_ENDPOINT, data).then(function (response) {
                        if (!response.success)
                            console.log("Error: " + response.message + " " + response.success);
                        else
                            setSubmissionData(response);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// case requestType == "post":
//   setSubmissionData(requestbody);
//   request
//     .post(endpoint, requestbody)
//     .then((response: any) => {
//       setSubmissionData(requestbody);
//       console.log("Success:", response);
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
//   return;
// if (response.success) setSubmissionData(response);
// else
//   showToastMessage({
//     isOpen: true,
//     message: response.message,
//     type: "error",
//   });
// case requestType == "put":
//   request
//     .put(
//       endpoint
//       //"https://api-gateway.techsophy.com/api/form-modeler/v1/forms/953135576945930240"
//     )
//     .then((response) => {
//       setSubmissionData(response);
//       console.log("Success:", response);
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
//       default:
//         return;
//     }
/*
{
      "name": "Form_custaat101",
      "components": {
        "display": "form",
        "components": [
          {
            "label": "Text Field",
            "labelPosition": "top",
            "labelWidth": "",
            "labelMargin": "",
            "placeholder": "",
            "description": "",
            "tooltip": "",
            "prefix": "",
            "suffix": "",
            "widget": { "type": "input" },
            "inputMask": "",
            "displayMask": "",
            "allowMultipleMasks": false,
            "customClass": "",
            "tabindex": "",
            "autocomplete": "",
            "hidden": false,
            "hideLabel": false,
            "showWordCount": false,
            "showCharCount": false,
            "mask": false,
            "autofocus": false,
            "spellcheck": true,
            "disabled": false,
            "tableView": true,
            "modalEdit": false,
            "multiple": false,
            "persistent": true,
            "inputFormat": "plain",
            "protected": false,
            "dbIndex": false,
            "case": "",
            "truncateMultipleSpaces": false,
            "encrypted": false,
            "redrawOn": "",
            "clearOnHide": true,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "allowCalculateOverride": false,
            "validateOn": "change",
            "validate": {
              "required": false,
              "minLength": "",
              "maxLength": "",
              "minWords": "",
              "maxWords": "",
              "pattern": "",
              "customMessage": "",
              "custom": "",
              "customPrivate": false,
              "json": "",
              "strictDateValidation": false,
              "multiple": false,
              "unique": false
            },
            "unique": false,
            "errorLabel": "",
            "errors": "",
            "key": "textField",
            "tags": [],
            "properties": {},
            "conditional": { "show": null, "when": null, "eq": "", "json": "" },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
              "style": "",
              "page": "",
              "left": "",
              "top": "",
              "width": "",
              "height": ""
            },
            "type": "textfield",
            "input": true,
            "refreshOn": "",
            "dataGridLabel": false,
            "addons": [],
            "inputType": "text",
            "id": "esb2x1",
            "defaultValue": null
          },
          {
            "type": "button",
            "label": "Submit",
            "key": "submit",
            "size": "md",
            "block": false,
            "action": "submit",
            "disableOnInvalid": true,
            "theme": "primary",
            "input": true,
            "placeholder": "",
            "prefix": "",
            "customClass": "",
            "suffix": "",
            "multiple": false,
            "defaultValue": null,
            "protected": false,
            "unique": false,
            "persistent": false,
            "hidden": false,
            "clearOnHide": true,
            "refreshOn": "",
            "redrawOn": "",
            "tableView": false,
            "modalEdit": false,
            "dataGridLabel": true,
            "labelPosition": "top",
            "description": "",
            "errorLabel": "",
            "tooltip": "",
            "hideLabel": false,
            "tabindex": "",
            "disabled": false,
            "autofocus": false,
            "dbIndex": false,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "widget": { "type": "input" },
            "attributes": {},
            "validateOn": "change",
            "validate": {
              "required": false,
              "custom": "",
              "customPrivate": false,
              "strictDateValidation": false,
              "multiple": false,
              "unique": false
            },
            "conditional": { "show": null, "when": null, "eq": "" },
            "overlay": {
              "style": "",
              "left": "",
              "top": "",
              "width": "",
              "height": ""
            },
            "allowCalculateOverride": false,
            "encrypted": false,
            "showCharCount": false,
            "showWordCount": false,
            "properties": {},
            "allowMultipleMasks": false,
            "addons": [],
            "leftIcon": "",
            "rightIcon": "",
            "id": "eygypbr"
          }
        ]
      },
      "type": "form"
    }
  }*/
//    "endpoint": "https://api-gateway.techsophy.com/api/form-modeler/v1/forms",
//# sourceMappingURL=SubmissionService.js.map